import { useTranslation } from "react-i18next";

export default function ProcessPanel() {
  const { t } = useTranslation();
  const steps = ["p1", "p2", "p3"];
  return (
    <section className="panel" data-side="left" id="process">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20nurse%20in%20teal%20scrubs%20standing%20with%20an%20elderly%20woman%20by%20a%20tall%20apartment%20window%20at%20blue%20hour%2C%20city%20lights%20beginning%20to%20glow%20outside%2C%20warm%20interior%20lamp%20light%2C%20soft%20haze%2C%20calm%20and%20reassuring%20mood%2C%20deep%20navy%20and%20teal%20color%20grading%2C%20editorial%20photography%2C%20no%20text&width=2400&height=1350&seq=nurse-process-03&orientation=landscape"
        alt={t("process.imageAlt")}
        width={2400}
        height={1350}
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>{t("process.stamp")}</p>
        <h2 data-reveal dangerouslySetInnerHTML={{ __html: t("process.h2") }} />
        <p className="sub" data-reveal>{t("process.sub")}</p>
        <ul className="num-list">
          {steps.map((s, i) => (
            <li key={s} data-reveal>
              <span className="idx">{`0${i + 1}`}</span>
              <div className="min-w-0">
                <p className="t">{t(`process.${s}`)}</p>
                <p className="d">{t(`process.${s}d`)}</p>
              </div>
            </li>
          ))}
        </ul>
        <a className="cta" href="#contact" data-reveal>
          {t("beat4.cta")}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}